import { render, staticRenderFns } from "./DeliveryItem.vue?vue&type=template&id=7f91f0b2"
import script from "./DeliveryItem.vue?vue&type=script&lang=ts"
export * from "./DeliveryItem.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryItem.vue?vue&type=style&index=0&id=7f91f0b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports